jQuery(document).ready(function () {

  var tabNumber;

  jQuery('.single-tab').click(function () {
    tabNumber = jQuery(this).attr('data-tab-target');
    jQuery('.single-tab, .content').removeClass('visible');
    jQuery("[tab-target='" + tabNumber + "']").addClass('visible');
    jQuery(this).addClass('visible');
  });

  jQuery("a#openmenu").click(function (e) {
    e.preventDefault();
    jQuery(".nf-header").toggleClass("open")
  });

  function scrollOnPageLoad() {
    // to top right away
    if (window.location.hash) scroll(0, 0);
    // void some browsers issue
    setTimeout(scroll(0, 0), 1);
    var hashLink = window.location.hash;
    if (jQuery(hashLink).length) {
      jQuery(function () {
        // *only* if we have anchor on the url
        // smooth scroll to the anchor id
        jQuery('html, body').animate({
          scrollTop: jQuery(window.location.hash).offset().top - 100
        }, 500);
      });
    }
  }
  scrollOnPageLoad();

  // function navbarPlaceholderDistance() {
  //   jQuery("main").css("marginTop", jQuery(".nf-header").outerHeight());
  // }
  // navbarPlaceholderDistance()
  // jQuery(window).resize(function () {
  //   navbarPlaceholderDistance()
  // });
  var scrollPos;
  jQuery(window).scroll(function () {

    scrollPos = jQuery(document).scrollTop();
    if (scrollPos >= 50) {
      jQuery(".nf-header").addClass("shadow")
    } else {
      jQuery(".nf-header").removeClass("shadow")
    }
  });

  // Startseite: Jeder zweite Produkt-Block bekommt eine Klasse, um den Inhalt zu reversen
  jQuery(".start__prodList .singleProd:nth-child(2n)").addClass("odd");

  var navHeight = $(".nf-header").outerHeight()

  document.querySelectorAll('a[href*="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      var target = anchor.hash;
      $('html, body').stop().animate({
        'scrollTop': $(target).offset().top - navHeight - 10
       }, 900, 'swing', function () {
        window.location.hash = target;
       });
    });
  });

  $("a[href*='#']").click(function() {
    console.log("123123")
  })

  

  jQuery(".mobile-menu-trigger").click(function (e) {
    e.preventDefault();
    jQuery(".mobileoffcanvasmenu, .header__overlay").addClass("visible");
  });
  jQuery(".header__overlay, .close-btn, .mobile-facets__open-wrapper").click(function () {
    jQuery(".mobileoffcanvasmenu, .header__overlay").removeClass("visible");
  });

  jQuery(".newsletter-link").click(function (e) {
    e.preventDefault();
    jQuery(".mobileoffcanvasmenu, .header__overlay").removeClass("visible");
    jQuery(".newsletter-modal, .header__overlay").addClass("visible");
  });
  jQuery(".newsletter-close, .bg-overlay").click(function (e) {
    jQuery(".newsletter-modal, .header__overlay").removeClass("visible");
  });

  // Navbar Fixed Placeholder
  // var navHeight
  // function navHeightSetzenUndPlaceholderFestlegen() {
  //   navHeight = jQuery(".nf-header").outerHeight();
  //   jQuery("main").css("margin-top", navHeight)
  //   return navHeight
  // }
  // navHeightSetzenUndPlaceholderFestlegen()
  // jQuery(window).resize(function () {
  //   navHeightSetzenUndPlaceholderFestlegen();
  // });

  // simple function to use for callback in the intersection observer
  const changeNav = (entries, observer) => {
    entries.forEach((entry) => {
      // verify the element is intersecting
      if(entry.isIntersecting && entry.intersectionRatio >= 0.55) {
        // remove old active class
        document.querySelector('.active').classList.remove('active');
        // get id of the intersecting section
        var id = entry.target.getAttribute('id');
        // find matching link & add appropriate class
        var newLink = document.querySelector(`.header__link[href$="#${id}"]`).classList.add('active');
      }
    });
  }

  // init the observer
  const options = {
    threshold: 0.55
  }

  const observer = new IntersectionObserver(changeNav, options);

  // target the elements to be observed
  const sections = document.querySelectorAll('.shop__featured-category');
  sections.forEach((section) => {
    observer.observe(section);
  });

  $(".locale-selectors__content").addClass("nf-container")
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}